import { useEffect, useMemo, useState } from "react";

export const presentFilterLabels = (rows, filterFns) =>
  Object.keys(filterFns).filter((label) => (rows || []).some(filterFns[label]));

// Chip labels that match at least one row. A selected chip that no longer
// matches anything (the last Private resource was removed) is cleared.
const usePresentFilter = (rows, filterFns) => {
  const [filter, setFilter] = useState(null);
  const options = useMemo(
    () => presentFilterLabels(rows, filterFns),
    [rows, filterFns]
  );

  useEffect(() => {
    if (filter != null && !options.includes(filter)) setFilter(null);
  }, [filter, options]);

  return { filter, setFilter, options };
};

export default usePresentFilter;
